import Vue from "vue"
export default (src_)=>{
    var script = document.createElement('script');
    script.type = 'text/jacascript';
    script.src = src_; //填自己的js路径
    Vue.prototype.$jquery('body').append(script);
}


// WEBPACK FOOTER //
// ./src/util/asy_add_ele.js